import styles from './NewBaseTable.module.scss';

type Props = {
  children: JSX.Element | JSX.Element[];
  id?: string
  className?: string;
};

const NewBaseTable = ({ id, children, className }: Props) => (
  <table id={id} className={[styles.table, className].join(' ')}>
    { children }
  </table>
);

export default NewBaseTable;
